import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import * as connectShopify from '@store/ducks/connect-shopify.duck';
import * as plan from '@store/ducks/myPlan.duck';
import * as incentivesSummary from '@store/ducks/Incentives/summary.duck';
import * as dailyIncentives from '@store/ducks/Incentives/dailyIncentives.duck';
import * as modeWiseIncentives from '@store/ducks/Incentives/modeWiseIncentives.duck';
import * as merchantIncentives from '@store/ducks/Incentives/merchantIncentives.duck';
import * as invoices from '@store/ducks/Incentives/invoices.duck';
import * as incentivesReports from '@store/ducks/Incentives/incentivesReports.duck';
import * as assessment from '@store/ducks/assessment.duck';
import * as reseller from '@store/ducks/reseller.duck';
import * as paymentStatus from '@store/ducks/paymentStatus.duck';
import * as otp from '@store/ducks/otp.duck';
import * as businessCategories from '@store/ducks/businessCategories.duck';
import * as hostedEsign from '@store/ducks/hostedEsign.duck';
import * as agreementEsign from '@store/ducks/agreementEsign.duck';

import * as filters from '@store/ducks/filters.duck';


export const rootReducer = combineReducers({
    connectShopify: connectShopify.reducer,
    paymentStatus: paymentStatus.reducer,
    assessment: assessment.reducer,
    reseller: reseller.reducer,
    plan: plan.reducer,
    incentivesSummary: incentivesSummary.reducer,
    dailyIncentives: dailyIncentives.reducer,
    modeWiseIncentives: modeWiseIncentives.reducer,
    merchantIncentives: merchantIncentives.reducer,
    invoices: invoices.reducer,
    incentivesReports: incentivesReports.reducer,
    otp: otp.reducer,
    businessCategories: businessCategories.reducer,
    hostedEsign: hostedEsign.reducer,
    agreementEsign: agreementEsign.reducer,

    filters: filters.reducer,

});

export function* rootSaga() {
    yield all([
        connectShopify.saga(),
        paymentStatus.saga(),
        reseller.saga(),
        plan.saga(),
        incentivesSummary.saga(),
        dailyIncentives.saga(),
        modeWiseIncentives.saga(),
        merchantIncentives.saga(),
        invoices.saga(),
        incentivesReports.saga(),
        assessment.saga(),
        otp.saga(),
        businessCategories.saga(),
        hostedEsign.saga(),
        agreementEsign.saga()
    ]);
};